// Must match `census.auth_status` values in IntellasureDB
const CensusFilterOptions = ["All", "Approved", "Pending", "Not Required"];

export default CensusFilterOptions;


